var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "visitor-profile-mobile" }, [
    _c("div", { staticClass: "visitor-profile-mobile-inner" }, [
      _c("div", { staticClass: "visitor-profile-mobile-avatar-wrapper" }, [
        _c("img", {
          staticClass: "visitor-profile-mobile-avatar",
          attrs: { src: _vm.userAvatar, alt: _vm.getUserData("name") },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "visitor-profile-mobile-data" }, [
        _c("h4", [_vm._v(_vm._s(_vm.getUserData("name") || _vm.$t("Agent")))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.getUserData("companyDisplayName")))]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }